import DelegateAccess from '@/types/delegate-access';
import { Avatar } from '@/views/components/design-system-v2';

export const getAvatarsFromDelegateAccess = (advisors: DelegateAccess[]): Avatar[] =>
  (advisors ?? []).map(delegate => {
    const nameParts = delegate.name.split(' ');
    return { _id: delegate.user, fname: nameParts[0], lname: nameParts.splice(1).join(' ') };
  });
